export default "__VITE_ASSET__BlDi4Yax__"